import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType } from 'vue';
import { VueAttributeClass } from '@/types/attributes-vue';
import AppIcon from '@/components/Base/AppIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListFilterButtonContent',
  props: {
  icon: {
    type: String,
    required: true,
  },
  class: {
    type: [String, Object] as PropType<VueAttributeClass>,
    default: 'items-center gap-2',
  },
  iconClass: {
    type: [String, Object] as PropType<VueAttributeClass>,
    default: 'h-[20px]',
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass([props.class, "flex"])
  }, [
    _createVNode(AppIcon, {
      src: props.icon,
      class: _normalizeClass(props.iconClass)
    }, null, 8, ["src", "class"]),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})